import "./App.css";

function App() {
  return (
    <div className="">
      <header className="App-header bg-[#fbf7f3]">
        <h1 className="font-[Dominance] text-[#a65c2d] text-6xl font-normal text-center">
          Coming Soon
        </h1>
        <div className="h-8" />
        <p className="font-[Nexa] text-[#5c5c4c] text-center">
          We are working hard to bring you a great experience. Stay tuned!
        </p>
      </header>
      {/* logo at the bottom */}
      <div className="absolute bottom-10 left-0 right-0">
        <img src="/wall8y.png" alt="logo" className="mx-auto w-auto h-12" />
      </div>
    </div>
  );
}

export default App;
